import React from "react";

import { Box } from "../../../primitive";
import { getXValueFromPercent } from "../utils";

export const ActiveSliderBar = ({
  hasFocus,
  leftKnobPercent,
  sliderPixelWidth,
  rightKnobPercent,
}: {
  hasFocus: boolean;
  leftKnobPercent: number;
  rightKnobPercent: number;
  sliderPixelWidth: number;
}) => {
  return (
    <Box
      height={2}
      top={9}
      backgroundColor={hasFocus ? "icon-main-primary" : "icon-primary"}
      left={getXValueFromPercent(leftKnobPercent, sliderPixelWidth) + 2}
      right={
        sliderPixelWidth -
        getXValueFromPercent(rightKnobPercent, sliderPixelWidth) -
        2
      }
      position="absolute"
    />
  );
};
